import { render, staticRenderFns } from "./SurgListEvent.vue?vue&type=template&id=5794593c"
import script from "./SurgListEvent.vue?vue&type=script&lang=js"
export * from "./SurgListEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports